import { createSlice } from "@reduxjs/toolkit";
import { getAxios, getRRAxios } from "./axiosActions";

export const initialState = {
    loadingCompany: false,
    loadingCompanyGet:false,
    hasErrors: false,
    companies: [],
    users: [],
    loadingUser: false,
    hasUserErrors: false
};

const companiesSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {
        getCompanies: state => {
            state.loadingCompanyGet = true;
        },
        getCompaniesSuccess: (state, { payload }) => {
            state.companies = payload;
            state.loadingCompanyGet = false;
            state.hasErrors = false;
        },
        getCompaniesFailure: state => {
            state.loadingCompanyGet = false;
            state.hasErrors = true;
        },
        getUsers: state => {
            state.loadingUser = true;
        },
        getUsersSuccess: (state, { payload }) => {
            state.users = payload;
            state.loadingUser = false;
            state.hasUserErrors = false;
        },
        getUsersFailure: state => {
            state.loadingUser = false;
            state.hasUserErrors = true;
        },
        getRefresh: state => {
            state.loadingCompany = true;
        },
        getRefreshSuccess: (state, { payload }) => {
            state.companies = payload;
            state.loadingCompany = false;
            state.hasErrors = false;
        },
        getRefreshFailure: state => {
            state.loadingCompany = false;
            state.hasErrors = true;
        },
    }
});

export const { getCompanies, getCompaniesSuccess, getCompaniesFailure,
    getUsers, getUsersSuccess, getUsersFailure, getRefresh, getRefreshSuccess, getRefreshFailure } = companiesSlice.actions;
export const companiesSelector = state => state.companies;
export default companiesSlice.reducer;
export function fetchCompanies() {
    return async dispatch => {
        dispatch(getCompanies());
        try {
            const params = { callTime: new Date() };
            const response = await getAxios('api/Company/GetCompanies', { params: params });
            if (response) {
                dispatch(getCompaniesSuccess(response));
            } else {
                dispatch(getCompaniesFailure());
            }
        } catch (error) {
            dispatch(getCompaniesFailure());
        }
    };
}
export function fetchUsers(companyId) {
    return async dispatch => {
        dispatch(getUsers());
        try {
            const params = { callTime: new Date() };
            const response = await getAxios('api/Users/GetUsers?companyId=' + companyId, { params: params });
            if (response) {
                dispatch(getUsersSuccess(response));
            } else {
                dispatch(getUsersFailure());
            }
        } catch (error) {
            dispatch(getUsersFailure());
        }
    };
}
export const refreshSnapshot = (companyId) => {
    return async dispatch => {

        dispatch(getRefresh());
        try {
            const params = { callTime: new Date() };
            const response = await getRRAxios('api/Company/RefreshCompany?companyId=' + companyId, { params: params });
            if (response) {
                dispatch(getRefreshSuccess(response));
                dispatch(fetchCompanies())
            } else {
                dispatch(getRefreshFailure());
            }

        } catch (error) {
            dispatch(getRefreshFailure());
        }
    };
}
